import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip, Row, Col, Drawer } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL } from '../../request'
import moment from 'moment'
import _ from 'lodash'
import async from 'async'

import { RightsWrapper } from '../../components/_utils/utils'
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const TabPane = Tabs.TabPane


@Form.create()
class CampaignScheduler extends Component {
  state = {
    visible: true,
    type: null,
    facebookCampaigns: [],
    campaignAdSet: [],
    campaignAds: [],
    allUsers: [],
    branchs: [],
    allCountries:[]
  }
  componentDidMount() {
    this.loadUsers()
    this.loadBranches()
    this.loadCountries()
    let { record } = this.props
    if (record && record._id) {
      this.loadFacebookCampaigns()
      this.loadFacebookAdSet(record.campaignId)
      this.loadFacebookAd(record.adsetId)
      this.setState({ type: record.type })
      setTimeout(() => {
        // this.props.form.setFieldsValue({startDate:moment(record.startDate), endDate:moment(record.endDate),...record})
        this.props.form.setFieldsValue({
          startDate: moment(record.startDate), endDate: moment(record.endDate),
          name: record.name, notifyTo: record.notifyTo, type: record.type, campaignId: record.campaignId ? record.campaignId : null, adsetId: record.adsetId ? record.adsetId : null, adId: record.adId ? record.adId : null, branchId: record.branchId._id, status: record.status
        })
      }, 400)
      this.props.form.setFieldsValue({})
    }
  }


  loadCountries = async() =>{
    let params = {
      results:1000,
      count:1000
    }
    Request.getCountries(params).then((res)=>{
      let data = res.data;
      if(data) {
        let allCountries = []
        async.each(data, (item)=>{
          allCountries.push({id:item._id, display:item.countryName})
        })
        this.setState({allCountries})
      }
    })
  }


  loadFacebookCampaigns = async () => {
    Request.getFacebookCampaigns().then((res) => {
      let data = res.data;
      if (data) {
        const facebookCampaigns = []
        async.each(data, (item) => {
          if (item.objective == "OUTCOME_LEADS" ||
            item.objective == "LEAD_GENERATION") {
            facebookCampaigns.push({
              id: item.id,
              display: item.name,
            })
          }
        })
        this.setState({ facebookCampaigns })
      }
    })
  }

  loadFacebookAdSet = async (campaignId) => {
    Request.getFacebookAdSets(campaignId).then((res) => {
      res.data = res.data.reduce((total, val) => {
        total.push({
          _id: val.id,
          key: val.id,
          display: val.name,
        });
        return total;
      }, []);
      this.setState({ campaignAdSet: res.data })
    })
  }

  loadFacebookAd = async (adsetId) => {
    Request.getAllAds(adsetId).then((res) => {
      res.data = res.data.reduce((total, val) => {
        total.push({
          id: val.id,
          key: val.id,
          display: val.name,
        });
        return total;
      }, []);
      this.setState({ campaignAds: res.data })
    })
  }

  loadBranches = () => {
    let params = {
      sortField: 'branchName',
      sortOrder: 'ascend',
      results: 1000,
      count: 1000,
      status: true
    }
    Request.loadBranch({ ...params })
      .then(resp => {
        resp.data = resp.data.reduce((temp, vv) => {
          temp.push({ id: vv._id, display: vv.branchName })
          return temp
        }, [])
        this.setState({ branchs: resp.data });
      })
      .catch(err => {
        console.log(err)
      })
  }

  loadUsers = async () => {
    let activeUser = JSON.parse(localStorage.getItem('user'))
    let params = {
      results: 10000,
      count: 10000
    }
    params.sortField = 'dateOfJoining'
    params.sortOrder = 'ascend'
    params.userBranch = activeUser.userBranch
    params.active = true
    params.userType = { $ne: "Student" }
    let data = await Request.loadUser({ ...params, regExFilters: ['name', 'email'] })
    let allUsers = []
    _.each(data.data, (user) => {
      allUsers.push({ _id: user._id, display: user.name })
    })

    this.setState({ allUsers })
  }




  handleSubmit = (e) => {
    let { form, record } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      let values = _.clone(valData)
      let x = null
      if(values.type === "Facebook") {
      let foundCampaign = this.state.facebookCampaigns.filter((obj) => {
        return obj.id === values.campaignId
      })
     
      values.campaignName = foundCampaign[0].display
    }
      if (record && record._id) {
        values._id = record._id
        x = await Request.updateCampaignScheduler(values)
      } else {
        x = await Request.addCampaignScheduler(values)
      }
      if (x.success) {
        notification.success({
          message: x.message
        })
      } else {
        notification.error({
          message: x.message
        })
      }
      this.onClose()
    })
  }

  onClose = () => {
    this.setState({ visible: false })
    setTimeout(() => {
      this.props.onClose()
    }, 400)
  }

  render() {
    let { visible, facebookCampaigns, campaignAdSet, campaignAds, allUsers, branchs, allCountries } = this.state
    let { form: { getFieldDecorator, setFieldsValue } } = this.props
    let inputTypes = {
      fields: [
        {
          label: 'Scheduler Name',
          key: 'name',
          required: true
        },
        {
          label: 'Scheduler Type',
          key: 'type',
          type: 'select',
          required: true,
          options: ['Google', 'Facebook'],
          onChange: v => {
            setFieldsValue({ type: v })
            if (v === "Facebook") {
              this.loadFacebookCampaigns()
            }
            this.setState({ type: v })
          }
        },
        {
          label: 'Choose Campaign',
          key: 'campaignId',
          type: 'select',
          showSearch: true,
          hidden: this.state.type === "Facebook" ? false : true,
          required: this.state.type === "Facebook" ? true : false,
          options: facebookCampaigns,
          onChange: v => {
            setFieldsValue({ campaignId: v })
            this.loadFacebookAdSet(v)
          }
        },
        {
          label: 'Choose Adset',
          key: 'adsetId',
          type: 'select',
          showSearch: true,
          hidden: this.state.type === "Facebook" ? false : true,
          required: this.state.type === "Facebook" ? true : false,
          options: campaignAdSet,
          onChange: v => {
            setFieldsValue({ adsetId: v })
            this.loadFacebookAd(v)
          }
        },
        {
          label: 'Choose Ad',
          key: 'adId',
          type: 'select',
          showSearch: true,
          hidden: this.state.type === "Facebook" ? false : true,
          required: this.state.type === "Facebook" ? true : false,
          options: campaignAds,
          onChange: v => {
            setFieldsValue({ adId: v })
          }
        },
        {
          label: 'Start Date',
          key: 'startDate',
          type: 'date',
          required: true
        },
        {
          label: 'End Date',
          key: 'endDate',
          type: 'date',
          required: true
        },
        {
          label: 'Notify To',
          key: 'notifyTo',
          type: 'select',
          mode: 'multiple',
          required: true,
          options: allUsers,
          showSearch: true,
          onChange: v => {
            setFieldsValue({ notifyTo: v })
          }
        },
        {
          label: 'Branch',
          key: 'branchId',
          type: 'select',
          required: true,
          options: branchs,
          showSearch: true,
          onChange: v => {
            setFieldsValue({ branchId: v })
          }
        },
        {
          label:'Country',
          key:'countryPreference',
          type:'select',
          showSearch:true,
          options:allCountries,
          onChange:v=>{
            setFieldsValue({ countryPreference: v })
          }
        },
        {
          label: 'Status',
          key: 'status',
          type: 'select',
          required: true,
          options: ["Active", "Inactive"],
          onChange: v => {
            setFieldsValue({ status: v })
          }
        },

      ]
    }
    return (
      <Drawer title={
        <div>
          <React.Fragment>
            {this.props.record && this.props.record._id ? "Edit" : "Add"} Campaign Scheduler
          </React.Fragment>
        </div>
      }
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={600}
        visible={visible}>
        <Card>
          <Form onSubmit={this.handleSubmit}>
            <GetAllFormFields inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} apiurl={API_URL} />
            <Row>
              <Col span={8} />
              <Col span={8}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginBottom: 10 }}
                  loading={this.props.loading}
                >
                  SAVE
                </Button>
              </Col>
              <Col span={8} />
            </Row>
          </Form>
        </Card>
      </Drawer>
    )
  }
}

@Form.create()
class FacebookCommunicationSettings extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    docObject: {},
    showSchedulerDrawer: false,
    defaultPageSize: '50',
    record: {}
  }
  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = await Request.addCommunicationSettings(values)


        if (!x.error) {
          notification.success({
            message: `Setting Updated Successfully`
          })
          this.getCommunicationSettings()
        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }

  chooseTab(value) {
    this.setState({
      activeTab: value
    })
  }
  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }


  editCampaignScheduler = (record) => {
    this.setState({ record: record, showSchedulerDrawer: true })
  }

  deleteCampaignScheduler = async (recordId) => {
    let response = await Request.deleteCampaignScheduler(recordId)
    if (response.success) {
      notification.success({
        message: response.message
      })
    } else {
      notification.error({
        message: response.message
      })
    }
    this.table.current.reload()
  }

  getCommunicationSettings() {
    Request.getCommunicationSettings().then(
      ({ doc, error, message }) => {
        if (!error && doc) {
          this.props.form.setFieldsValue({
            fbAccessToken: doc.fbAccessToken,
            fbBusinessId:doc.fbBusinessId
          })
          this.setState({ docObject: doc });
        } else {
          notification.error({
            message: 'Error Getting Data',
            description: message
          })
        }
      }
    )
  }


  openSchedulerDrawer = () => {
    this.setState({ showSchedulerDrawer: true })
  }
  closeSchedulerDrawer = () => {
    this.setState({ showSchedulerDrawer: false, record: {} }, () => {
      this.table.current.reload()
    })
  }

  apiRequest = async (params) => {
    return new Promise(async (resolve) => {
      let response = await Request.getAllCampaignSchedulers(params)
      return resolve(response)
    })
  }

  componentWillMount() {
    this.getCommunicationSettings()
  }

  async componentDidMount() {
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  render() {
    const { dispatch } = this.props
    const {
      form: { getFieldDecorator, setFieldsValue }
    } = this.props
    const { id, defaultPageSize } = this.state;

    const facebookSettingInputTypes = {
      fields: [
        {
          label:'Business Account Id',
          key:'fbBusinessId'
        },
        {
          label: 'Facebook Access Token',
          key: 'fbAccessToken',
          type: 'textarea',
          rows: '8'
        }
      ]
    };

    let columns = [
      {
        title: 'Scheduler Name',
        key: 'name'
      },
      {
        title: 'Type',
        key: 'type'
      },
      {
        title: 'Start Date',
        key: 'startDate',
        render: (text, record) => (
          <div>{moment(record.startDate).format(dateFormat)}</div>
        )
      },
      {
        title: 'End Date',
        key: 'endDate',
        render: (text, record) => (
          <div>{moment(record.endDate).format(dateFormat)}</div>
        )
      },
      {
        title: 'Branch',
        key: 'branchId',
        dataIndex: 'branchId.branchName'
      },
      {
        title: "Campaign",
        key: 'campaignName'
      },
      {
        title: 'Status',
        key: 'status'
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <div>
            <Tooltip title="Edit Campaign Scheduler">
              <Button
                loading={false}
                size="small"
                onClick={() => { this.editCampaignScheduler(record) }}
                shape="circle"
                icon="edit"
              />
            </Tooltip>
            <Tooltip title="Delete Campaign Scheduler">
              <Button
                loading={false}
                size="small"
                onClick={() => { this.deleteCampaignScheduler(record._id) }}
                shape="circle"
                icon="delete"
              />
            </Tooltip>
          </div>
        )
      }
    ]

    return (
      <PageHeaderWrapper title={` Communication Settings `}>
        {
          this.state.showSchedulerDrawer ?
            <CampaignScheduler record={this.state.record} onClose={this.closeSchedulerDrawer} />
            : null
        }
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={'Facebook Settings'} key={0}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <GetAllFormFields
                  inputSchema={facebookSettingInputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}
                >
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{ marginBottom: 10, marginLeft: '1%' }}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
            <TabPane tab={"Campaign Scheduler"} key={1}>
              <Row>
                <Col span={22}></Col>
                <Col span={2}>
                  <Button type='primary' onClick={this.openSchedulerDrawer}>Add</Button>
                </Col>
              </Row>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 900 } }}
                pagination={{
                  showSizeChanger: false,
                  defaultPageSize: defaultPageSize,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }} />
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default FacebookCommunicationSettings
